export default {
  en: {
    keyword: 'Keyword',
    transfer: 'Transfer',
    name: 'Name',
    price: 'Price',
    unit: 'Unit',
    pax: 'Pax',
    status: 'Status',
    conditionDetail: 'Condition',
    transferUnitTypeCar: '/ Car',
    transferUnitTypePerPerson: '/ Person',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedTransferMessage: 'This transfer has been updated',
    deletedTransferMessage: 'This transfer has been deleted'
  },
  th: {
    keyword: 'คำที่ต้องการค้นหา',
    transfer: 'รถรับส่ง',
    name: 'ชื่อ',
    price: 'ราคา',
    unit: 'หน่วย',
    pax: 'จำนวน',
    status: 'สถานะ',
    conditionDetail: 'เงื่อนไขและรายละเอียด',
    transferUnitTypeCar: '/ คัน',
    transferUnitTypePerPerson: '/ คน',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedTransferMessage: 'รถรับส่งนี้มีการแก้ไข',
    deletedTransferMessage: 'รถรับส่งนี้ถูกลบไปแล้ว'
  }
}
